"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var enums_1 = require("../enums");
var appender_console_native_1 = require("../appenders/appender.console-native");
var appender_console_1 = require("../appenders/appender.console");
var appender_remote_1 = require("../appenders/appender.remote");
var appender_empty_1 = require("../appenders/appender.empty");
var appender_bi_remote_1 = require("../appenders/appender.bi-remote");
/**
 * basic typed array intersection implementation to reuse code blocks.
 * returns the array intersection, e.g.
 * ```ts
 * intersect([0, 1, 2], [4, 3, 2]) // [2]
 * intersect(["i", "know"], ["i", "don't", "know", "that", "i", "know"]) // ["i", "know"]
 * ```
 * @typeParam T any primitive or specified types
 * @param array1 fie
 * @param array2
 */
function intersect(array1, array2) {
    return array1.filter(function (value) { return array2.indexOf(value) !== -1; });
}
/**
 * all specified appender types which are not custom (excluding empty appender)
 */
var nonCustomTypes = [enums_1.AppenderType.Console, enums_1.AppenderType.ConsoleNative, enums_1.AppenderType.Remote, enums_1.AppenderType.BIRemote];
/**
 * maps appender type with auto-assigned appender, fallbacks to {@link EmptyAppender}
 */
var typeMapper = (_a = {},
    _a[enums_1.AppenderType.Console] = appender_console_1.ConsoleAppender,
    _a[enums_1.AppenderType.ConsoleNative] = appender_console_native_1.ConsoleNativeAppender,
    _a[enums_1.AppenderType.Remote] = appender_remote_1.RemoteAppender,
    _a[enums_1.AppenderType.Empty] = appender_empty_1.EmptyAppender,
    _a[enums_1.AppenderType.Custom] = appender_empty_1.EmptyAppender,
    _a[enums_1.AppenderType.BIRemote] = appender_bi_remote_1.BIRemoteAppender,
    _a);
/**
 * Determines what happens when configs is being overridden with another appenders and appender types.
 * @param oldConfig old config if exists
 * @param newConfig new (partial) config
 * @param setConfigOptions special options fo config set
 */
function populateAppenders(oldConfig, newConfig, setConfigOptions) {
    if (setConfigOptions.mode === enums_1.ConfigMode.Debug) {
        console.log("oldConfig: " + JSON.stringify(oldConfig));
        console.log("newConfig: " + JSON.stringify(newConfig));
        console.log("setConfigOptions: " + JSON.stringify(setConfigOptions));
    }
    // new appenders are
    // 1. all custom appenders specified explictly.
    var newAppenders_1 = newConfig.appenders ? newConfig.appenders : [];
    // 1.1 all new appenders which are set explicitly if `setConfigOptions.keepExplicitlySetAppenders` is described as true (e.g. useful for the unit tests)
    // If this options is on, if you want to overwrite old appenders, set so in the config!
    // e.g. (timber.setConfig({appenderTypes: [AppenderType.Console], appenders: []})
    if (!setConfigOptions.keepExplicitlySetAppenders) {
        newAppenders_1 = newAppenders_1.filter(function (x) { return x.type == enums_1.AppenderType.Custom; });
    }
    // 2. appenders set via _new_ appender types
    var previousAppenderTypes = oldConfig && oldConfig.appenderTypes ? oldConfig.appenderTypes : [];
    var newAppendersFromTypes_2 = newConfig.appenderTypes.map(function (x) { return new typeMapper[x](); })
        .filter(function (x) { return x.type !== enums_1.AppenderType.Empty; })
        .filter(function (x) { return previousAppenderTypes.indexOf(x.type) === -1; });
    // 2.1. if appender from appenders field is set explictly, we don't need to populate it from appenderTypes.
    var newAppenderTypesFromAppenders = intersect(newAppenders_1.map(function (x) { return x.type; }), nonCustomTypes);
    newAppendersFromTypes_2 = newAppendersFromTypes_2.filter(function (x) { return newAppenderTypesFromAppenders.indexOf(x.type) === -1; });
    // 3. old appenders with same appender types in old and new config.
    var oldAppenders = oldConfig && oldConfig.appenders ? oldConfig.appenders : [];
    var preservedAppenders_3 = oldAppenders.filter(function (x) { return newConfig.appenderTypes.indexOf(x.type) !== -1; });
    // 3.1. If we have non-custom new appenders (1.) set explicitly, old appenders are not included;
    var oldAppenderTypesFromAppenders = intersect(oldAppenders.map(function (x) { return x.type; }), nonCustomTypes);
    var oldAppenderTypesFromNewAppenders = intersect(newAppenders_1.map(function (x) { return x.type; }), oldAppenderTypesFromAppenders);
    preservedAppenders_3 = preservedAppenders_3.filter(function (x) { return oldAppenderTypesFromNewAppenders.indexOf(x.type) === -1; });
    newConfig.appenders = newAppenders_1
        .concat(newAppendersFromTypes_2)
        .concat(preservedAppenders_3);
    if (setConfigOptions.mode === enums_1.ConfigMode.Debug) {
        console.log("resultedConfig: " + JSON.stringify(newConfig));
    }
    return newConfig;
}
exports.populateAppenders = populateAppenders;
//# sourceMappingURL=appenders.population.js.map